import React from 'react';
import { Switch } from 'react-router-dom';
import { RouteWithLayout } from './components';
import { MainLayout,FullLayout,AuthLayout } from './layout';
import { Home,Contact, About, Gallery, NotFound, Causes,Blog, BlogDetails,CauseDetails, BlogCategory, Faq, Team, Register } from './views';
import * as ROUTES from './utils/constants/routes';


const AppRouter = () => {
  return (
    <Switch>
      <RouteWithLayout
        component={Home}
        path={ROUTES.LANDING}
        layout={MainLayout} exact />
        
        <RouteWithLayout
        component={Contact}
        path={ROUTES.CONTACT}
        layout={MainLayout} />
        <RouteWithLayout
        component={About}
        path={ROUTES.ABOUT}
        layout={MainLayout} />
        <RouteWithLayout
        component={Gallery}
        path={ROUTES.GALLERY}
        layout={MainLayout} />
        <RouteWithLayout
        component={Causes}
        path={ROUTES.CAUSES}
        layout={MainLayout} exact/>

        <RouteWithLayout
          component={CauseDetails}
          path={ROUTES.CAUSESDETAILS}
          layout={MainLayout} /> 
        <RouteWithLayout
        component={Blog}
        path={ROUTES.BLOG}
        layout={MainLayout} exact/>
        <RouteWithLayout
        component={BlogDetails}
        path={ROUTES.BLOGDETAILS}
        layout={MainLayout} />
        <RouteWithLayout
        component={BlogCategory}
        path={ROUTES.CATEGORY_BLOG_POSTS}
        layout={MainLayout} />
        <RouteWithLayout
        component={Faq}
        path={ROUTES.FAQ}
        layout={MainLayout} />
        <RouteWithLayout
        component={Team}
        path={ROUTES.TEAM}
        layout={MainLayout} />
                <RouteWithLayout
        component={Register}
        path={ROUTES.BECOME_VOLUNTEER}
        layout={AuthLayout} />
        <RouteWithLayout
        component={NotFound}
        path={ROUTES.NOTFOUND}
        layout={FullLayout} />
    </Switch>
  );
}

export default AppRouter;
